// トップスライダーの起動 // Launch the top slider

const swiper = new Swiper(".top-swiper", {
  speed: 1000, // スライド変化時間
  loop: true,
  loopAdditionalSlides: 1,
  autoplay: {
    delay: 4000, //　スライダー表示時間
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    clickable: true,
  },
});

const logoSwiper = new Swiper('.logo-slider', {
  loop: true,

  slidesPerView: 'auto',
  spaceBetween: 12,

  speed: 5000,

  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },

  allowTouchMove: false,
});

const imgSwiper = new Swiper('.img-slider', {
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 0,
  speed: 5000,

  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },

  allowTouchMove: false,
});

jQuery(function ($) {
	let caseSwiper = null;

	function initCaseSwiper() {
		if ($(window).width() <= 768) {
			if (!caseSwiper) {
				caseSwiper = new Swiper(".js-caseSwiper", {
					slidesPerView: 'auto',
          spaceBetween: 16,
          centeredSlides: true,
          loop: true,
					navigation: {
						nextEl: ".js-caseSwiper .swiper-button-next",
						prevEl: ".js-caseSwiper .swiper-button-prev",
					},
				});
			}
		} else {
			if (caseSwiper) {
				caseSwiper.destroy(true, true);
				caseSwiper = null;
			}
		}
	}

	initCaseSwiper();

	$(window).on("resize", function () {
		initCaseSwiper();
	});
});
